module.exports = __webpack_public_path__ + "static/media/re.6af24572.png";